var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDbSyncAll = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_10909)",
    fill: "#8D939C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9524 11.1307L19.0199 11.2337C19.1943 12.8112 18.8209 14.4238 17.9685 15.7745C17.1042 17.1438 15.781 18.1818 14.2425 18.6971C13.5059 18.9438 12.7493 19.062 12 19.0619C9.8368 19.0618 7.73746 18.0764 6.3808 16.3541H7.30968V15.4159H4.80115V18.04H5.73934V17.0518C6.63396 18.1411 7.81959 18.9905 9.16571 19.4916C10.0753 19.8302 11.0348 20 11.9931 20C12.8557 20 13.7173 19.8624 14.5404 19.5867C16.2833 19.0029 17.7825 17.8269 18.7618 16.2753C19.7272 14.7456 20.1501 12.9186 19.9524 11.1307Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99871 8.28436C6.86286 6.88814 8.19783 5.83146 9.75767 5.30893C11.2767 4.80014 12.8747 4.8163 14.379 5.3558C15.5537 5.77711 16.601 6.50852 17.3999 7.45346L16.5058 7.45314L16.5055 8.39133L19.0418 8.39218V5.88546H18.1036V6.83311C17.2002 5.77018 16.0193 4.94739 14.6957 4.47268C12.9911 3.86139 11.1805 3.84293 9.45974 4.41933C7.69264 5.01124 6.18021 6.20852 5.20099 7.79058C4.23452 9.35208 3.83114 11.2095 4.06514 13.0207L4.99558 12.9006C4.78911 11.3025 5.14536 9.66308 5.99871 8.28436Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4005 11.2501C15.4005 10.2901 14.6195 9.50907 13.6595 9.50907C13.508 9.50907 13.3582 9.52835 13.2143 9.56635L12.9043 9.64822L12.7668 9.35857C12.5221 8.84325 11.9966 8.51025 11.4281 8.51025C10.6116 8.51025 9.94732 9.17453 9.94732 9.99103V10.5097H9.41448C8.33801 10.5097 7.44845 11.3726 7.44229 12.4491C7.43611 13.5299 8.31357 14.4112 9.39301 14.4112H15.1319C15.9194 14.4112 16.5578 13.7728 16.5578 12.9853C16.5578 12.2973 16.0437 11.7296 15.3788 11.6444L15.397 11.3587C15.3993 11.3225 15.4005 11.2859 15.4005 11.2501Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_10909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDbSyncAll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_db_sync_all.a5a76fa43524c66493b1a311eba81099.svg";